import React, { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";

export default function ImageModal({ image, onClose }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (image) {
            setIsVisible(true);
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [image]);

    const handleClose = () => {
        setIsVisible(false);
        setIsLoaded(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    if (!image) return null;

    return (
        <div
            style={{ zIndex: 999999 }}
            className={`tw-fixed tw-inset-0 tw-flex tw-justify-center tw-items-center tw-p-4 tw-transition-all tw-duration-300 tw-ease-out ${
                isVisible ? "tw-bg-black/80 tw-backdrop-blur-sm" : "tw-bg-black/0"
            }`}
            onClick={handleClose}
        >
            <div
                className={`tw-relative tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-out tw-transform tw-w-[90vw] tw-max-w-5xl tw-h-[85vh] tw-flex tw-flex-col ${
                    isVisible ? "tw-scale-100 tw-opacity-100 tw-translate-y-0" : "tw-scale-95 tw-opacity-0 tw-translate-y-4"
                }`}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="tw-absolute tw-top-4 tw-right-4 tw-bg-black/60 hover:tw-bg-black/80 tw-text-white tw-rounded-full tw-p-2 tw-transition-all tw-duration-200 tw-backdrop-blur-sm tw-z-10 tw-shadow-lg hover:tw-scale-110"
                    onClick={handleClose}
                    aria-label="Close modal"
                >
                    <RxCross1 size={18} />
                </button>

                <div className="tw-relative tw-flex tw-justify-center tw-items-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-flex-1 tw-p-4">
                    {!isLoaded && (
                        <div className="tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center">
                            <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-4 tw-border-primary tw-border-t-transparent"></div>
                        </div>
                    )}
                    <img
                        src={image}
                        alt="Preview"
                        className={`tw-max-w-full tw-max-h-full tw-object-contain tw-transition-opacity tw-duration-300 ${
                            isLoaded ? "tw-opacity-100" : "tw-opacity-0"
                        }`}
                        onLoad={() => setIsLoaded(true)}
                    />
                </div>

                <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gradient-to-t tw-from-black/50 tw-to-transparent tw-text-white tw-p-4 tw-pointer-events-none">
                    <p className="tw-text-sm tw-font-medium tw-text-center tw-drop-shadow-lg">Press ESC or click outside to close</p>
                </div>
            </div>
        </div>
    );
}
